module.exports = __webpack_public_path__ + "img/8d0f590dc0c1c7598dce2e2c563caeb9.png";